import { Edit, MoreVertical, Trash2 } from "react-feather";
import styles from "./complaintcard.module.css";
import { Dropdown } from "react-bootstrap";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";

const ComplaintCard = ({ complaintData, setDelModalOpen, setEditModalOpen }) => {
    const { user, isAuthenticated } = useAuth0();
    const [carouselImages, setCarouselImages] = useState([]);

    useEffect(() => {
        if (complaintData) {
            let cImages = complaintData?.images?.map(i => {
                if (i?.file_path.split('.').pop() === 'jpeg' || i?.file_path.split('.').pop() === 'jpg' || i?.file_path.split('.').pop() === 'png' || i?.file_path.split('.').pop() === 'svg') {
                    return i;
                }
                return null;
            });

            cImages = cImages?.filter(i => i !== null);
            setCarouselImages(cImages);
        }
    }, [complaintData])

    return (<div className={`${styles.SMProCusSmallDiv}`}>
        <div className={`${styles.CardSmall}`}>
            {carouselImages?.length > 0 && <div className={`${styles.RequestCarouselSec} RequestCarouselSec`}>
                <Carousel autoPlay={true} showThumbs={false} showArrows={false} showStatus={false} showIndicators={carouselImages?.length > 1} interval="3000">
                    {carouselImages?.slice(0, 5).map((item, index) => {
                        return <div key={index}>
                            <img src={item?.file_public_url} alt="" />
                        </div>
                    })}
                </Carousel>
            </div>}
            <ul className={`${styles.CaseSummSideUL}`}>
                <li>
                    <p className={`${styles.ULtitle}`}>Property</p>
                    <p className={`${styles.ULData}`}>{complaintData?.property_name}</p>
                </li>
                <li>
                    <p className={`${styles.ULtitle}`}>Apartment No</p>
                    <p className={`${styles.ULData}`}>{complaintData?.apt_name}</p>
                </li>
                <li>
                    <p className={`${styles.ULtitle}`}>Submitted By</p>
                    <p className={`${styles.ULData}`}>{complaintData?.submitted_by_name}</p>
                </li>
                <li>
                    <p className={`${styles.ULtitle}`}>Tenant</p>
                    <p className={`${styles.ULData}`}><Link to={`/people/tenants/details/${complaintData?.tenant_id}`}>{complaintData?.tenant_name}</Link></p>
                </li>
                <li>
                    <p className={`${styles.ULtitle}`}>Submitted Date</p>
                    <p className={`${styles.ULData}`}>{dayjs(complaintData?.created_at).format("L")}</p>
                </li>
                <li>
                    <p className={`${styles.ULtitle}`}>Complaint Number</p>
                    <p className={`${styles.ULData}`}>{complaintData?.complaint_no}</p>
                </li>
                <li>
                    <p className={`${styles.ULtitle}`}>Status</p>
                    <p className={`${styles.ULData}`}>{complaintData?.current_status_text}</p>
                </li>
                <li>
                    <p className={`${styles.ULtitle}`}>Importance:</p>
                    <p className={`${styles.ULData}`}>{complaintData?.priority_text}</p>
                </li>
            </ul>

            {(isAuthenticated && (user['https://propertydek.com/permissions'].indexOf('complaint:update') > -1 || user['https://propertydek.com/permissions'].indexOf('complaint:delete') > -1)) && <Dropdown className={`${styles.ProEditSec}`}>
                <Dropdown.Toggle className={`${styles.EditActionsBU} ProsDrBU`} id="dropdown-basic">
                    <MoreVertical />
                </Dropdown.Toggle>

                <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                    {user['https://propertydek.com/permissions'].indexOf('complaint:update') > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => setEditModalOpen(true)}>
                        <Edit /> Edit
                    </Dropdown.Item>}
                    {user['https://propertydek.com/permissions'].indexOf('complaint:delete') > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => setDelModalOpen(true)}>
                        <Trash2 /> Delete
                    </Dropdown.Item>}
                </Dropdown.Menu>
            </Dropdown>}
        </div>
    </div>);
}

export default ComplaintCard;